import { FC, ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import useFeatureFlag from '~/common/hooks/useFeatureFlag';

interface Props {
  flag: string;
  redirectTo: string;
  children: ReactNode;
}

/**
 * Renders its children only while `flag` is on, redirecting once it is known to be off.
 * @param redirectTo path inside the current realm, e.g. `/settings`
 */
export const ReasoningFlagGate: FC<Props> = ({
  flag,
  redirectTo,
  children
}) => {
  const { realm } = useParams<{ realm: string }>();
  const { treatments } = useFeatureFlag([flag]);
  const treatment = treatments[flag]?.treatment;

  // useTreatments evaluates on a shared Split client that becomes ready after
  // the one behind SplitContext.isReady, answering 'control' in between; a
  // redirect on that bounces every hard refresh out of the page
  if (!treatment || treatment === 'control') return null;

  return treatment === 'on' ? (
    <>{children}</>
  ) : (
    <Navigate replace to={`/${realm}${redirectTo}`} />
  );
};
